import Immutable from 'immutable';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { AnalyticsScreenViewMiddleware, AnalyticsTrackMiddleware } from './analytics/middleware';
import SentryMiddleWare from './middlewares/SentryMiddleware';
import reducer from './reducers';
const isDev = process.env.NODE_ENV !== 'production';
export const createReduxStore = () => {
  const middleware = [AnalyticsScreenViewMiddleware, AnalyticsTrackMiddleware, thunk, SentryMiddleWare];
  if (isDev && window.__REDUX_DEVTOOLS_EXTENSION__) {
    const reduxDevtools = window.__REDUX_DEVTOOLS_EXTENSION__({
      serialize: {
        immutable: Immutable
      }
    });
    return createStore(reducer, compose(applyMiddleware(...middleware), reduxDevtools));
  } else {
    return createStore(reducer, applyMiddleware(...middleware));
  }
};